module.exports = __webpack_public_path__ + "img/video_play.a3831a86.svg";